import { IS_WEB_VIEW } from "common/constants.ts";
import { shareContent } from "services/webview/webViewBridgeUtils.ts";
import { getDownloadFileUrl, openMessage } from "utils/misc.tsx";
import { useState } from "react";
import { IS_TELEGRAM_WEB_APP } from "features/telegram/constants";
import { telegramDownloadFile } from "features/telegram/utils.ts";

const useDownloadFile = () => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadFile = (fileUrl: string, fileName: string) => {
    if (IS_WEB_VIEW) {
      setIsLoading(true);
      shareContent({ url: fileUrl, title: fileName })
        .catch(() => {
          openMessage(
            "Something went wrong while trying to download this file. Please contact support."
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (IS_TELEGRAM_WEB_APP) {
      telegramDownloadFile(fileUrl, fileName);
    } else {
      getDownloadFileUrl(fileUrl)
        .then((url) => {
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {});
    }
  };

  return {
    isLoading,
    setIsLoading,
    downloadFile,
  };
};

export default useDownloadFile;
